import { render, staticRenderFns } from "./validatePreBet.vue?vue&type=template&id=40feff96"
import script from "./validatePreBet.vue?vue&type=script&lang=js"
export * from "./validatePreBet.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports